import axios from "../../Axios/axiosConfig";

export class ControlUnitStateService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }

    getControlUnitState = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/state`);
    }

}
